export const productTransform = product => ({
  mainImage: product['main_image'],
  productName: product['product_name'],
  skuCode: product['sku_code'],
});
